import type * as React from 'react';
import { put } from '@Domain/Api';
import aiCostLimitUpdated, {
	type AiCostLimitUpdatedAction,
} from '@Application/AiCostLimits/Limits/Actions/aiCostLimitUpdated';
import aiCostLimitUpdateFailed, {
	type AiCostLimitUpdateFailedAction,
} from '@Application/AiCostLimits/Limits/Actions/aiCostLimitUpdateFailed';
import type { AiCostLimitPayload } from '@Application/AiCostLimits/Limits/Actions/aiCostLimitsFetched';
import type UpdateAiCostLimit from '@Application/AiCostLimits/Limits/Commands/UpdateAiCostLimit';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiCostLimitUpdatedAction | AiCostLimitUpdateFailedAction;

export default (command: UpdateAiCostLimit) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<AiCostLimitPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-cost-limits/${command.limitId}`,
				command.toJSON(),
			);

			const action = aiCostLimitUpdated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostLimitUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
